import { api } from "../api";

export type SbpPaymentStatus =
  | "AWAITING_CONFIRMATION"
  | "PENDING"
  | "IN_PROGRESS"
  | "SUCCEEDED"
  | "FAILED"
  | "CANCELLED";

export interface SbpPayment {
  id: string;
  status: SbpPaymentStatus;
  qr_payload: string;
  amount: string | null;
  currency: string;
  usdt_amount: string | null;
  fee_amount: string | null;
  external_ref: string | null;
  error_message: string | null;
  worker_id: string | null;
  created_at: string;
  updated_at: string;
  completed_at: string | null;
  /** USDT-эквивалент (usdt + fee) для preview на экране подтверждения. */
  usdt_estimate: string | null;
  /** Курс USDT→RUB, использованный при расчёте preview. */
  rate: string | null;
  /** Момент подтверждения оплаты юзером — воркер по нему поймёт «жми оплатить». */
  confirmed_at: string | null;
  /** Название получателя, распознанное на экране банка (`БФПН "Алёша"`). */
  recipient: string | null;
  /** Метод/банк (обычно «СБП»). */
  bank_name: string | null;
}

export interface CreateSbpPaymentInput {
  /** Строка из QR-кода СБП (URL `https://qr.nspk.ru/...` или иные payload'ы). */
  qrPayload: string;
  /** Опциональная сумма в рублях, если QR статичный без суммы. Отправляется как строка. */
  amount?: string;
}

export async function createSbpPayment(
  input: CreateSbpPaymentInput,
): Promise<SbpPayment> {
  const res = await api.post<SbpPayment>("/me/payments/qr", {
    qrPayload: input.qrPayload,
    amount: input.amount,
  });
  return res.data;
}

export async function getSbpPayment(id: string): Promise<SbpPayment> {
  const res = await api.get<SbpPayment>(`/me/payments/${id}`);
  return res.data;
}

export async function cancelSbpPayment(id: string): Promise<SbpPayment> {
  const res = await api.post<SbpPayment>(`/me/payments/${id}/cancel`);
  return res.data;
}

/**
 * Подтверждает оплату из WebApp: переводит задачу из AWAITING_CONFIRMATION
 * в PENDING. После этого её берёт Android-воркер и автоматически жмёт
 * «Оплатить» в приложении банка.
 */
export async function confirmSbpPayment(id: string): Promise<SbpPayment> {
  const res = await api.post<SbpPayment>(`/me/payments/${id}/confirm`);
  return res.data;
}
